import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType, BiDataHook } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import CommentOutline from '@wix/da-ds/pkg/Icons/24x24/CommentOutline';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarToggleButton from '../../_partials/items/ActionBarToggleButton';
import ActionBarButtonRestricted from '../../_partials/ActionBarButtonRestricted';
var CommentButton = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, deviationId = _b.deviationId, author = _b.author, extended = _b.extended, onToggleCommentPanel = _a.onToggleCommentPanel, isCommentPanelOpen = _a.isCommentPanelOpen, isOwner = _a.isOwner, actionBarType = _a.actionBarType;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var addCommentLabel = useFlag('addacomment');
    var onClick = useCallback(function () {
        if (!extended) {
            return;
        }
        onToggleCommentPanel(deviation, actionBarType);
    }, [extended, onToggleCommentPanel, deviation, actionBarType]);
    return (React.createElement(ActionBarButtonRestricted, { subscribersOnly: true, deviation: deviation, tooltip: isOwner ? t('actionbar.comment') : undefined, button: React.createElement(ActionBarToggleButton, { activated: isCommentPanelOpen, onClick: onClick, "data-hook": BiDataHook.DEVIATION_COMMENT_BUTTON, biData: {
                evid: BiEventType.THUMB_CLICK_COMMENT,
                typeid: getDeviationResourceType(deviation),
                creatorid: author && author.useridUuid,
                itemid: deviationId,
            }, label: isOwner || isMobile
                ? undefined
                : addCommentLabel
                    ? t('actionbar.comment.label')
                    : t('actionbar.comment'), icon: CommentOutline }) }));
};
CommentButton.displayName = 'CommentButton';
export default CommentButton;
//# sourceMappingURL=CommentButton.js.map